import script from "./CustomPages.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPages.vue?vue&type=script&setup=true&lang=js"

import "./CustomPages.vue?vue&type=style&index=0&id=2bd6989c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd6989c"]])

export default __exports__